import { Menu, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { toast } from "react-toastify";
import { useSearchParams } from "react-router-dom";
//@ts-ignore
import { usePDFPrintHook } from "@careinfo/layout";
import APIS from "../../constant/EndPoint";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
export default function OrderMenu(props: any) {
  const [searchParams, setSearchParms] = useSearchParams();
  const { downloadPrint, isPrintLoading } = usePDFPrintHook();
  const handleLabelPrintDownload = async () => {
    const selectedOrder = searchParams.get("selectedItems")?.split(",");
    if (!selectedOrder?.length) {
      toast.error("Please select at least one order first");
      return;
    }
    const url = `${APIS.ORDER}label-print/`;
    let formData = {
      order_ids: selectedOrder,
    };
    try {
      const res = await downloadPrint(url, formData);
    } catch (err) {
      console.log(err);
    }
  };
  const handleOrderReceiptDownload = async () => {
    const selectedOrder = searchParams.get("selectedItems")?.split(",");
    if (!selectedOrder?.length) {
      toast.error("Please select at least one order first");
      return;
    }
    const url = `${APIS.ORDER}order-receipt-print/`;
    let formData = {
      order_ids: selectedOrder,
    };
    try {
      const res = await downloadPrint(url, formData);
      searchParams.delete("selectedItems");
      setSearchParms(searchParams);
    } catch (err) {
      console.log(err);
    }
  };

  const handleButtonClick = (type: string) => {
    const selectedOrder = searchParams.get("selectedItems")?.split(",");
    if (!selectedOrder?.length) {
      toast.error("Please select at least one order first");
      return;
    }
    props?.setOrderActionMenu(true);
    props?.setActionType(type);
  };

  return (
    <div className={tw` top-16 text-right`}>
      <Menu as="div" className={tw`relative inline-block text-left`}>
        <div>
          <Menu.Button
            className={tw`inline-flex w-full justify-center rounded-md text-primary px-2 text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75`}
          >
            Action
          </Menu.Button>
        </div>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items
            className={tw`absolute mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none`}
          >
            <div className={tw`px-1 py-1`}>
              <Menu.Item>
                {({ active }) => (
                  <button
                    onClick={handleLabelPrintDownload}
                    className={tw`${
                      active ? tw`bg-primary text-white` : tw`text-gray-900`
                    } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                  >
                    Label Print
                  </button>
                )}
              </Menu.Item>
            </div>
            <div className={tw`px-1 py-1`}>
              <Menu.Item>
                {({ active }) => (
                  <button
                    onClick={() => handleOrderReceiptDownload()}
                    className={tw`${
                      active ? tw`bg-primary text-white` : tw`text-gray-900`
                    } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                  >
                    Order Receipt
                  </button>
                )}
              </Menu.Item>
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
}
